import { useParams } from "react-router";
import { ClientDetail } from "@/components/clients/ClientDetail";

export const meta = () => [
  { title: "Client | Ani Tech" },
  { name: "description", content: "Client knowledge centre" },
];

export default function ClientRoute() {
  const params = useParams<{ id?: string }>();
  return <ClientDetail faClientId={params.id ?? ""} />;
}

/** Named export consumed by OS-mode window registry. */
export function ClientDetailRoute({ faClientId }: { faClientId: string }) {
  return <ClientDetail faClientId={faClientId} />;
}
